import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';

@Component({
  selector: 'app-new-recipient',
  standalone: false,
  templateUrl: './new-recipient.component.html',
  styleUrl: './new-recipient.component.scss'
})
export class NewRecipientComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  translate: any;

  constructor(
    public modalRef: BsModalRef,
    private languageTranslateService: LanguageTranslateService
  ){
    super();
  }

  ngOnInit(){
    this.getLanguageData();
  }
  getLanguageData() {
    this.push(this.languageTranslateService.wordSrc$.subscribe(data => { 
      if(Object.keys(data).length != 0){
        this.translate = data
      }
    }))
    console.log("translate",this.translate)
    //this.mainLabel = this.translate?.accessories.label.plural
  }

  push(obs:any) {
    super.push(obs);
  }

}
